import * as AuthHelper from './APIHelper';

export const PostTransferBlobStorage = (payload) => {
    return AuthHelper.postResponse('/transferblobstorage', payload);
}